import { useLocation, useNavigate } from "react-router-dom";

import {
    FaList,
    FaSuitcase,
    FaHistory,
    FaCalendarAlt,
    FaUserClock,
    FaCog,
    FaSignOutAlt
} from "react-icons/fa";

import AvailableTours from "./AvailableTours";
import MyTours from "./MyTours";
import History from "./History";
import GuideCalendar from "./GuideCalendar";
import Availability from "./Availability";
import Settings from "./Settings";

export default function GuideMobileLayout() {
const navigate = useNavigate();
const location = useLocation();

const tab =
    location.pathname.split("/")[2] || "available";

    const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user");

    sessionStorage.removeItem("token");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("user");

    navigate("/login");
};

    const renderContent = () => {

        switch (tab) {

            case "available":
                return <AvailableTours />;

            case "mine":
                return <MyTours />;

            case "history":
                return <History />;

            case "calendar":
                return <GuideCalendar />;

            case "availability":
                return <Availability />;

            case "settings":
                 return <Settings />;

            default:
                return <AvailableTours />;

        }

    };

    return (

        <div style={page}>

            <div style={content}>

                {renderContent()}

            </div>

            <div style={bottomBar}>

                <NavButton
                    icon={<FaList />}
                    text="Tours"
                    active={tab === "available"}
                    onClick={() => navigate("/guide/available")}
                />

                <NavButton
                    icon={<FaSuitcase />}
                    text="Mine"
                    active={tab === "mine"}
                    onClick={() => navigate("/guide/mine")}
                />

                <NavButton
                    icon={<FaHistory />}
                    text="History"
                    active={tab === "history"}
                    onClick={() => navigate("/guide/history")}
                />

                <NavButton
                    icon={<FaCalendarAlt />}
                    text="Calendar"
                    active={tab === "calendar"}
                    onClick={() => navigate("/guide/calendar")}
                />

                <NavButton
                    icon={<FaUserClock />}
                    text="Availability"
                    active={tab === "availability"}
                    onClick={() => navigate("/guide/availability")}
                />

                <NavButton
                     icon={<FaCog />}
                     text="Settings"
                     active={tab === "settings"}
                     onClick={() => navigate("/guide/settings")}
                />

               <NavButton
                    icon={<FaSignOutAlt />}
                    text="Logout"
                    active={false}
                    onClick={handleLogout}
                    danger
                />

            </div>

        </div>

    );

}

function NavButton({ icon, text, active, onClick, danger }) {
    return (
        <button
            onClick={onClick}
            style={{
                ...button,
                color: danger ? "#DC2626" : active ? "#C75028" : "#64748B"
            }}
        >
            {icon}
            <div style={{ fontSize: 11 }}>{text}</div>
        </button>
    );
}

const page = {

    minHeight: "100vh",

    display: "flex",

    flexDirection: "column",

    background: "#F8FAFC"

};

const content = {

    flex: 1,

    overflowY: "auto",

    paddingBottom: 75

};

const bottomBar = {

    position: "fixed",

    left: 0,

    right: 0,

    bottom: 0,

    height: 70,

    background: "white",

    borderTop: "1px solid #E2E8F0",

    display: "flex",

    justifyContent: "space-around",

    alignItems: "center"

};

const button = {

    border: "none",

    background: "none",

    display: "flex",

    flexDirection: "column",

    alignItems: "center",

    cursor: "pointer",

    fontSize: 20

};